import { PAGE_LINKS } from '@/helpers/commonConsts'
import Loadable from '@/router/loadable'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { PcApp } from './pcApp'

const PcHomePage = Loadable(lazy(() => import('@/pages/pc/HomePage/HomePage')))
const PcGoodsDetailPage = Loadable(lazy(() => import('@/pages/pc/GoodsDetailPage/GoodsDetailPage')))
const PcSearchPage = Loadable(lazy(() => import('@/pages/pc/SearchPage/SearchPage')))
const JBangAiPage = Loadable(lazy(() => import('@/pages/pc/JBangAiPage/JBangAiPage')))
const MyOrdersPage = Loadable(lazy(() => import('@/pages/pc/MyOrders/MyOrdersPage')))
const MyPurchasedPage = Loadable(lazy(() => import('@/pages/pc/myPurchased/MyPurchasedPage')))
const CouponPage = Loadable(lazy(() => import('@/pages/pc/CouponPage/CouponPage')))
const MyCouponsPage = Loadable(lazy(() => import('@/pages/pc/MyCoupons/MyCouponsPage')))
const CouponCenterPage = Loadable(lazy(() => import('@/pages/pc/CouponCenterPage/CouponCenterPage')))

const pcRoutes: RouteObject[] = [
  {
    path: PAGE_LINKS.pcHome,
    element: <PcApp />,
    children: [
      {
        path: '',
        element: <PcHomePage />,
      },
      {
        path: `${PAGE_LINKS.pcGoodsDetail}/:goodsNamePinyin/:id/:goodsType`,
        element: <PcGoodsDetailPage />,
      },
      {
        path: `${PAGE_LINKS.pcGoodsDetail}/:goodsNamePinyin/:id/:goodsType/:resourceId`,
        element: <PcGoodsDetailPage />,
      },
      {
        path: `${PAGE_LINKS.pcSearch}/:searchText`,
        element: <PcSearchPage />,
      },
      {
        path: PAGE_LINKS.pcJBAI,
        element: <JBangAiPage />,
      },
      {
        path: PAGE_LINKS.pcMyOrders,
        element: <MyOrdersPage />,
      },
       {
        path: PAGE_LINKS.pcMyPurchased,
        element: <MyPurchasedPage />,
      },
      {
        path: PAGE_LINKS.pcMyCoupons,
        element: <MyCouponsPage />,
      },
      {
        path: PAGE_LINKS.pcCoupon,
        element: <CouponPage />,
      },
      {
        path: PAGE_LINKS.pcCouponCenter,
        element: <CouponCenterPage />,
      },
    ],
  },
]

export default pcRoutes
